var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("outlined-card", {
    staticClass: "card-hover-border",
    attrs: { showDivider: false, hover: true, href: _vm.notesLink() },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c("v-icon", { staticClass: "primary--text mr-1" }, [
              _vm._v("\n            mdi-bookmark-multiple-outline\n        "),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "text-body-1 font-weight-medium" }, [
              _vm._v("Notes and Bookmarks"),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "loading-block",
              { attrs: { "is-loading": _vm.loadingCounts } },
              [
                _c(
                  "div",
                  { staticClass: "w-full" },
                  [
                    _vm.countAll
                      ? [
                          _c(
                            "div",
                            { staticClass: "text-h6 font-weight-medium mb-2" },
                            [_vm._v(_vm._s(_vm.getNotesCountMessage()))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-body-2 text--secondary" },
                            [_vm._v("Last 30 days")]
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "text-h6 font-weight-medium mb-2" },
                            [_vm._v("No notes yet")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-body-2 text--secondary" },
                            [_vm._v("Add notes to get started")]
                          ),
                        ],
                  ],
                  2
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }